/**
 * This is an implementation of a globally configurable base path for the site to use for
 * prefixing routes. For the time being, this will live in a global accessable through
 * the get and set functions defined here. Moving forward, a more principled solution
 * will replace this, however, in the short term this was need to allow other changes
 * to progress.
 */

let basePath = '';
/**
 * Get the globally configured base path.
 * @returns the globally configured base path.
 */
export const getBasePath = () => basePath;
/**
 * Set the global base path configuration.
 *
 * @param pathPrefix to configure globally
 *
 * Changing this value will cause all routes to be prefixed with the new value so it should
 * only be done during the bootstrapping phase of the app runtime.
 */
export const setBasePath = (pathPrefix: string) => {
  basePath = pathPrefix;
};
